<template>
    <section v-if="show" class="h-screen">
        <div class="flex flex-wrap bg-blue-50">
            <div class="flex flex-col w-full">
                <div class="bg-blue-50 pb-4">
                    <header class="pt-6">
                        <div class="mx-auto px-4 sm:px-6 lg:px-8">
                            <div class="flex items-stretch">
                                <div class="flex-1 self-center px-1">
                                    <h1 class="text-2xl leading-9 font-bold text-blue-900">
                                        {{ meeting.title }}
                                    </h1>
                                    <h3 class="text-xl font-bold text-blue-900">
                                        {{ meeting.date }} om {{ meeting.time }}
                                    </h3>
                                </div>
                                <div class="flex-initial self-end">
                                    <logo-nl height="h-24" class="h-24" v-if="!logo"></logo-nl>
                                    <img :src="logo" class="h-24 w-auto" v-if="logo" />
                                </div>
                            </div>
                        </div>
                    </header>
                </div>
                <sidebar
                    v-if="room.name"
                    class="live-sidebar"
                    :pusher="room.slug"
                    :room="room.slug"
                    :tab_poll="room.slug"
                    :tab_info="room.slug"
                    :tab_document="meeting.hash"
                    :meeting="meeting.hash"
                    :backstage="false"
                ></sidebar>
            </div>
        </div>
    </section>
</template>

<style scoped>
.live-sidebar {
    width: 100% !important;
    max-width: 100% !important;
}
</style>

<script>
export default {
    mounted() {
        Eventing.fire("checkAuthStatus");
        this.getRoom(this.$route.params.slug);
    },
    data() {
        return {
            show: false,
            room: {
                embed: null,
            },
            meeting: {},
            logo: null,
        };
    },
    created() {
        this.slug = this.$route.params.slug;
        localStorage.removeItem('redirect-to-live');
    },
    methods: {
        setLogo() {
            try {
                this.logo = document.head.querySelector('meta[name="logo"]')?.content;
            } catch (error) {}
        },
        getRoom(slug) {
            var self = this;
            axios
                .get("/api/meetings/" + slug)
                .then((response) => {
                    self.meeting = response.data.data;
                    self.room = response.data.data.room;
                    self.show = true;
                    self.setLogo();
                    self.$nextTick(() => {
                        Eventing.fire("hideTabChats");
                        Eventing.fire("hideTabAttendees");
                    });
                })
                .catch((error) => {});
        },
    },
};
</script>
